import { InnerLabelTextfield, TextField } from "components/commons";
import React from "react";
import { checkIfValidByDecimalPlaces, formatNumber, unformatNumber } from "utils";

const InputLitre = ({ className, onChange, onBlur, innerLabel, ...props }) => {
  const componentProps = {
    ...props,
    className,
    onChange: (name, { value }) => {
      const integerPart = value.toString().split(".")[0].replace(/,/g, "");
      if (integerPart.length > 15) return;
      if (checkIfValidByDecimalPlaces(value, 3) || !value) {
        onChange(name, { value });
      }
    },
    onBlur: (name, { value }) => {
      if (value) {
        const formattedValue = `${formatNumber(value)}${!innerLabel ? " L" : ""}`;
        onChange(name, { value: formattedValue });
        onBlur?.(name, { value });
      }
    },
    onFocus: () => {
      if (props.value) {
        const value = unformatNumber(props.value, "L");
        onChange(props.name, { value: value || "" });
      }
    },
  };
  if (innerLabel) {
    return <InnerLabelTextfield {...componentProps} prefix="L" />;
  }
  return <TextField {...componentProps} />;
};

export default InputLitre;
